import { Logger } from '@/shared/logger/logger';

import { CountryCodeInfo, countryCodeMap } from './region_to_country_code';

export function getCountryInfo(regionCode: string): CountryCodeInfo {
  const countryInfo = countryCodeMap[regionCode];
  if (!countryInfo) {
    Logger.debug('Unknown region code', { regionCode });
    return { code: '', maxLength: 15 };
  }
  return countryInfo;
}

export function removeNonDigits(phoneNumber: string): string {
  return phoneNumber.replaceAll(/\D/g, '');
}

export function removeLeadingZeros(phoneNumber: string): string {
  return phoneNumber.replace(/^0+/, '');
}

export function removeCountryCode(
  phoneNumber: string,
  countryCode: string,
): string {
  return phoneNumber.startsWith(countryCode)
    ? phoneNumber.slice(countryCode.length)
    : phoneNumber;
}

export function addCountryCode(
  phoneNumber: string,
  countryCode: string,
): string {
  return countryCode + phoneNumber;
}

export function checkMinLength(phoneNumber: string, minLength: number): void {
  if (phoneNumber.length < minLength) {
    Logger.warn('Normalized number is shorter than minimum length', {
      minLength,
      phoneNumber,
    });
  }
}

export function normalizePhoneNumber(
  phoneNumber: string,
  regionCode: string,
): string {
  try {
    const countryInfo = getCountryInfo(regionCode);
    const { code: countryCode } = countryInfo;
    // if there are no digit chars, return the original number
    if (!/\d/.test(phoneNumber)) {
      return phoneNumber;
    }

    let normalizedNumber = removeNonDigits(phoneNumber);
    normalizedNumber = removeLeadingZeros(normalizedNumber);
    normalizedNumber = removeCountryCode(normalizedNumber, countryCode);
    normalizedNumber = removeLeadingZeros(normalizedNumber);
    normalizedNumber = addCountryCode(normalizedNumber, countryCode);

    // checkMinLength(normalizedNumber, minLength);

    return normalizedNumber;
  } catch (error) {
    Logger.error('Error normalizing phone number', {
      error,
      phoneNumber,
      regionCode,
    });
    return phoneNumber;
  }
}
